export interface Certification {
  id: string
  title: string
  type: 'Certification' | 'Accreditation' | 'Membership'
  descriptor: string
  issuedBy: string
  appliesTo: string
  intro: string
  whyItMatters: string[]
  scope: {
    description: string
    items: string[]
  }
  hasPdf: boolean
  externalLink?: string
}

export const certificationsData: Certification[] = [
  {
    id: 'iso-9001-2015',
    title: 'ISO 9001:2015',
    type: 'Certification',
    descriptor: 'Quality management system',
    issuedBy: 'BSI (British Standards Institution)',
    appliesTo: 'Chiltern Global operations (scope on request)',
    intro:
      'Our ISO 9001:2015 certification demonstrates our commitment to consistently providing products and services that meet customer and regulatory requirements.',
    whyItMatters: [
      'Ensures structured processes for consistent product quality and reliability.',
      'Provides supply chain assurance through documented quality procedures and regular audits.',
      'Drives operational consistency and a framework for continuous improvement.',
    ],
    scope: {
      description:
        'The scope of our quality management system covers our core manufacturing and procurement activities. Specific details are available on request.',
      items: [
        'Product design and development processes',
        'Manufacturing quality control',
        'Supply chain management and vendor assessment',
        'Customer satisfaction monitoring',
      ],
    },
    hasPdf: true,
  },
  {
    id: 'iso-14001-2015',
    title: 'ISO 14001:2015',
    type: 'Certification',
    descriptor: 'Environmental management system',
    issuedBy: 'BSI (British Standards Institution)',
    appliesTo: 'Chiltern Global operations (scope on request)',
    intro:
      'We are committed to minimising our environmental impact. Our ISO 14001:2015 certification verifies that we have an effective environmental management system in place.',
    whyItMatters: [
      'Demonstrates compliance with environmental regulations and risk management.',
      'Provides assurance of sustainable sourcing and supply chain practices.',
      'Ensures operational consistency in waste reduction and resource efficiency.',
    ],
    scope: {
      description:
        'Our environmental management system applies across our primary facilities. Scope details available on request.',
      items: [
        'Waste reduction and recycling programmes',
        'Energy efficiency monitoring',
        'Sustainable material sourcing policies',
        'Environmental impact assessments',
      ],
    },
    hasPdf: true,
  },
  {
    id: 'cyber-essentials-plus',
    title: 'Cyber Essentials Plus',
    type: 'Certification',
    descriptor:
      'UK Government-backed cyber security scheme (independently verified)',
    issuedBy: 'Cyber Tec Security',
    appliesTo: 'Chiltern Global IT infrastructure',
    intro:
      'As a supplier to defence and government organisations, data security is paramount. We hold the UK Government-backed Cyber Essentials Plus certification.',
    whyItMatters: [
      'Mitigates risk against common cyber threats through independently verified controls.',
      'Provides assurance for the secure handling of sensitive procurement data.',
      'Maintains operational consistency in IT security and access management.',
    ],
    scope: {
      description:
        'The certification covers our core IT infrastructure and data handling processes. Scope details available on request.',
      items: [
        'Boundary firewalls and internet gateways',
        'Secure configuration of systems',
        'Access control and user management',
        'Malware protection and patch management',
      ],
    },
    hasPdf: true,
  },
  {
    id: 'joscar',
    title: 'JOSCAR',
    type: 'Accreditation',
    descriptor: 'Defence supply chain accreditation',
    issuedBy: 'Hellios (JOSCAR Accreditation Authority)',
    appliesTo: 'Chiltern Global corporate entity',
    intro:
      'Chiltern Global is fully registered on the Joint Supply Chain Accreditation Register (JOSCAR), demonstrating compliance for defence and aerospace supply chains.',
    whyItMatters: [
      'Reduces procurement risk through verified corporate governance and compliance.',
      'Streamlines supply chain onboarding for prime contractors.',
      'Ensures operational consistency across security, environmental, and ethical standards.',
    ],
    scope: {
      description:
        'JOSCAR accreditation covers a comprehensive review of our corporate policies and procedures. Scope details available on request.',
      items: [
        'Corporate governance and financial stability',
        'Information security compliance',
        'Environmental and sustainability standards',
        'Anti-bribery and corruption policies',
      ],
    },
    hasPdf: true,
  },
  {
    id: 'make-uk-defence',
    title: 'Make UK Defence',
    type: 'Membership',
    descriptor: 'UK defence industry trade association membership',
    issuedBy: 'Make UK Defence',
    appliesTo: 'Chiltern Global corporate entity',
    intro:
      'We are proud members of Make UK Defence, the national defence trade association, connecting us with the wider UK defence manufacturing ecosystem.',
    whyItMatters: [
      'Ensures alignment with current defence sector policies and regulations.',
      'Provides access to supply chain development and industry best practices.',
      'Maintains operational consistency through regulatory guidance and updates.',
    ],
    scope: {
      description:
        'Membership provides access to industry resources and advocacy. Scope details available on request.',
      items: [
        'Defence sector policy advocacy',
        'Industry networking and events',
        'Supply chain development support',
        'Regulatory guidance and updates',
      ],
    },
    hasPdf: false,
    externalLink: 'https://www.makeuk.org/about/make-uk-defence',
  },
]
